export default __webpack_public_path__ + "081678887c410f31e016868c778e4239.png";